import PropTypes from 'prop-types'
import { useState, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { Container, Row, Col, Input } from 'reactstrap'
import { isPunchoutUiMode } from '../../util/punchout'
import { isValidEmail } from '../../util/utils'

const PunchoutEmailInput = ({ value, onChange, nameValue, onNameChange }) => {
  const session = useSelector(state => state.session)
  const currentLocation = useSelector(state => state.storeViews.current)
  const collectsPunchoutContact = !!currentLocation?.punchout_collect_email
  const show = isPunchoutUiMode({ session, currentLocation }) && collectsPunchoutContact
  const emailLabel = currentLocation?.punchout_contact_email_label?.trim() || 'Contact Email'
  const nameLabel = currentLocation?.punchout_contact_name_label?.trim() || 'Contact Name'
  const emailRequired = collectsPunchoutContact && !!currentLocation?.punchout_contact_email_required
  const nameRequired = collectsPunchoutContact && !!currentLocation?.punchout_contact_name_required

  const [emailTouched, setEmailTouched] = useState(false)
  const normalizedValue = (value || '').trim()
  const emailValid = !normalizedValue || isValidEmail(normalizedValue)

  const handleEmailChange = useCallback(
    e => {
      const newEmail = e.target.value
      setEmailTouched(true)
      onChange?.(newEmail)
    },
    [onChange]
  )

  const handleNameChange = useCallback(
    e => {
      onNameChange?.(e.target.value)
    },
    [onNameChange]
  )

  if (!show) {
    return null
  }

  return (
    <div className="box-shadow white-background mf-m-0">
      <div className="ckout-header">
        <h5 className="mf-m-0">Punchout Contact</h5>
      </div>
      <Container className="mf-mb-4">
        <Row className="align-items-start mf-p-3">
          <Col xs="12">
            <p className="mf-mb-2">{emailRequired ? `${emailLabel} *` : emailLabel}</p>
            <Input
              placeholder={emailLabel}
              name="punchout_contact_email"
              type="email"
              value={value || ''}
              onChange={handleEmailChange}
              className={!emailValid && emailTouched ? 'is-invalid' : ''}
              autoComplete="email"
              required={emailRequired}
              aria-required={emailRequired}
            />
            {!emailValid && emailTouched && (
              <div className="text-danger small mf-mt-1">Please enter a valid email.</div>
            )}
          </Col>
          <Col xs="12" className="mf-mt-2">
            <p className="mf-mb-2">{nameRequired ? `${nameLabel} *` : nameLabel}</p>
            <Input
              placeholder={nameLabel}
              name="punchout_contact_name"
              type="text"
              value={nameValue || ''}
              onChange={handleNameChange}
              maxLength={255}
              autoComplete="name"
              required={nameRequired}
              aria-required={nameRequired}
            />
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default PunchoutEmailInput

PunchoutEmailInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  nameValue: PropTypes.string,
  onNameChange: PropTypes.func
}
